import { render } from "./GuardHome.vue?vue&type=template&id=c998dec0&scoped=true"
import script from "./GuardHome.vue?vue&type=script&lang=js"
export * from "./GuardHome.vue?vue&type=script&lang=js"

import "./GuardHome.vue?vue&type=style&index=0&id=c998dec0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c998dec0"]])

export default __exports__